module.exports = __webpack_public_path__ + "assets/img/37_1549.d636fe7d.jpg";